export enum TrackingEvent {
  ContextPanelHover = `[Context Panel] Hover`,
}
